import Accordion from './util/accordion';

class MobileMenu {
  constructor({ el, btn, btns }) {
    this.el = el;
    this.body = document.querySelector('body');
    this.header = this.body.querySelector('.header');
    this.root = el.parentNode;
    this.mobileMenuContainerItems = this.root.querySelector(
      '[data-mobile-menu-items]'
    );

    this.menuItems = this.mobileMenuContainerItems.querySelectorAll(
      '[data-mobile-menu-item]'
    );
    this.btn = btn;
    this.btns = btns;
    this.init();
  }

  init() {
    this.btn.addEventListener('click', () => this.toggle());

    this.btns.forEach((btn) => {
      btn.addEventListener('click', (event) => this.toggleMenuItem(event));
    });

    this.menuItems.forEach((menuItem) => {
      const backBtn = menuItem.querySelector('[data-mobile-menu-item-back]');
      if (!backBtn) return;
      backBtn.addEventListener('click', () => {
        const menuItemBtn = this.root.querySelector(
          `[data-mobile-menu-item-btn="${menuItem.dataset.mobileMenuItem}"]`
        );
        menuItem.classList.remove('active');
        if (menuItemBtn) menuItemBtn.classList.remove('active');
        if (this.header) this.header.classList.remove('active');
      });
    });

    // Any real link inside the menu (same tab or new tab) closes the menu
    this.root.addEventListener('click', (event) => {
      const link = event.target.closest('a[href]');
      if (!link || !this.el.classList.contains('active')) return;
      const href = link.getAttribute('href');
      if (!href || href.charAt(0) === '#') return;
      this.close();
    });

    // Back/forward cache: restore the page with the menu closed
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) this.close();
    });

    this.initAccordions();
  }

  initAccordions() {
    const accordions =
      this.mobileMenuContainerItems.querySelectorAll('[data-accordion]');

    accordions.forEach((accordion) => {
      new Accordion(accordion);
    });
  }

  toggle() {
    if (this.el.classList.contains('active')) {
      this.close();
    } else {
      this.btn.classList.add('active');
      this.el.classList.add('active');
      this.body.classList.add('no-scroll');
    }
  }

  close() {
    this.btn.classList.remove('active');
    this.el.classList.remove('active');
    this.body.classList.remove('no-scroll');
    if (this.header) this.header.classList.remove('active');
    this.btns.forEach((btn) => btn.classList.remove('active'));
    this.menuItems.forEach((menuItem) => menuItem.classList.remove('active'));
  }

  toggleMenuItem(event) {
    const btn = event.currentTarget;
    const menuItem = Array.from(this.menuItems).find(
      (item) => btn.dataset.mobileMenuItemBtn === item.dataset.mobileMenuItem
    );
    // No submenu for this item: nothing to open
    if (!menuItem) return;

    const isActive = menuItem.classList.toggle('active');
    btn.classList.toggle('active', isActive);
    if (this.header) this.header.classList.toggle('active', isActive);
  }
}

export default MobileMenu;
